// #ring_size
// body.template_product-signature-monogram {}
// #monogram

const add_to_cart_button = document.querySelector('body.template_product-signature-monogram .shopify-product-form button[type=submit]');
add_to_cart_button.textContent  = "Please Select Your Ring Size";
add_to_cart_button.disabled = true;

//const form = document.querySelector('body.template_product-signature-monogram .shopify-product-form');

//form.addEventListener('submit', function(event) {
//  event.preventDefault(); // Prevent default form submission
//  event.stopPropagation();
  //const selectedValue = getSelectedRadioValue('option2');
  
//  let elements = document.getElementsByName("properties[Ring Size]");
  //console.log('%c elements: ' + elements[0], 'background: #222; color: #bada55');
  //elements[0].value = event.target.options[event.target.selectedIndex].value;
//  const selectedValue = elements[0].value;
//  if (selectedValue) {
//    console.log('Selected value:', selectedValue);
//    form.submit();
//  } else {
//    console.log('No radio button selected.');
//    alert("Please Select Your Ring Size");
//    return false;
//  }
  
  // Add loading message
  //const submitButton = document.querySelector('button[type="submit"]');
  //submitButton.textContent = "Adding product...";
  
  // Perform your actions here (e.g., AJAX request)
  // Example:
  //setTimeout(() => {
    // Simulate a successful request
    //alert("Product added to cart!");
    //submitButton.textContent = "Add to cart";
    //form.submit(); // Submit the form after finishing your logic
  // }, 1000);
//});

function getSelectedRadioValue(name) {
  const radioButtons = document.getElementsByName(name);
  for (let i = 0; i < radioButtons.length; i++) {
    if (radioButtons[i].checked) {
      return radioButtons[i].value;
    }
  }
  return null; // Return null if no radio button is selected
}

var monogram_box = document.getElementById("monogram");

monogram_box.onchange = function(event){
  var monogram_text = event.target.value;
  //console.log('%c Ring Size Selected: ' + variant_size, 'background: #222; color: #bada55');

  //// properties[Your Ring Size]
///// <div class="product-info__block-item" data-block-type="line-item-property">
  /////// properties[Your Monogram]

  let elements = document.getElementsByName("properties[Monogram]");
  //console.log('%c elements: ' + elements[0], 'background: #222; color: #bada55');
  elements[0].value = monogram_text;
  
};




var selection = document.getElementById("ring_size");

selection.onchange = function(event){
  var variant_size = event.target.options[event.target.selectedIndex].dataset.priced;
  console.log('%c Ring Size Selected: ' + variant_size, 'background: #222; color: #bada55');

  //// properties[Your Ring Size]
///// <div class="product-info__block-item" data-block-type="line-item-property">
  /////// properties[Your Monogram]

  let elements = document.getElementsByName("properties[Ring Size]");
  //console.log('%c elements: ' + elements[0], 'background: #222; color: #bada55');
  elements[0].value = event.target.options[event.target.selectedIndex].value;
  
  var sizing_radios = document.querySelectorAll('input[type="radio"]');
  var sizing_radios_array = [...sizing_radios]; // converts NodeList to Array
  sizing_radios_array.forEach(radio => {
    if(radio.name == 'option2') {
      if(radio.value.toLowerCase() == variant_size.toLowerCase()) {
        console.log('%c Variant Found: ' + radio.value + ' Matching Ring: ' + variant_size, 'background: orange; color: #fff');
        //radio.selected = 'selected'; //.dispatchEvent(new Event('click'));
        const radio_label = findLableForControl(radio);
        //console.log('%c Label Found: ' + radio_label.textContent, 'background: orange; color: #fff');
        radio_label.click();
        const add_to_cart_button = document.querySelector('body.template_product-signature-monogram .shopify-product-form button[type=submit]');
        add_to_cart_button.textContent  = "Add To Cart";
        add_to_cart_button.disabled = false;
      }
    }
  });
};

function findLableForControl(el) {
  var idVal = el.id;
  const labels = document.getElementsByTagName('label');
  for( var i = 0; i < labels.length; i++ ) {
    if (labels[i].htmlFor == idVal) {
      //console.log(labels[i]);
      return labels[i];
    }
  }
}

var engraving_option = document.querySelectorAll('body.template_product-signature-monogram variant-picker fieldset:nth-child(3) .block-swatch');
var engraving_option_array = [...engraving_option]; // converts NodeList to Array
engraving_option_array.forEach(div => {
  //console.log(div);
  div.onclick = function(event) {
    document.getElementById("monogram").style.display = 'block';
    document.getElementById("monogram_label").style.display = 'block';
    //console.log('%c Engraving Selected: ' + parseInt(div.textContent), 'background: #632; color: #fff');
    if(! isNaN(parseInt(div.textContent))) {
      document.getElementById("monogram").value = '';
      document.getElementById("monogram").setAttribute('maxlength',parseInt(div.textContent));
      document.getElementById("monogram_label").innerHTML = "Monogram (up to " + parseInt(div.textContent) + " characters):";
    }else{
      document.getElementById("monogram").value = '';
      document.getElementById("monogram").style.display = 'none';
      document.getElementById("monogram_label").style.display = 'none';  
    }
  };
});




